import { render, staticRenderFns } from "./pageSvg.vue?vue&type=template&id=67252717&"
import script from "./pageSvg.vue?vue&type=script&lang=js&"
export * from "./pageSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports